<template>
<div class="">
  <section class="section is-title-bar">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <p class="title is-5">Order Tats CSV Report :</p>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <router-link :to="{ name: 'ReportDetails' }" class="button is-small is-link">Back to
            List</router-link>
        </div>
      </div>
    </div>
  </section>

  <section class="section is-main-section">
    <div class="columns">
          <div class="column is-3">
            <div class="box">
            <div class="has-text-centered p-b-2">
              <div class="content">
                <div class="field">
                  <p class="subtitle is-5 has-text-black m-t-25"><span class="requir">*</span>TAT Report Type</p>
                  <div class="control">
                    <span class="select is-fullwidth">
                      <select required v-model="reportType" @change="handleDateinput">
                        <option value="" selected>---Select---</option>
                        <option :value="reportTypes[key]" v-for="key in Object.keys(reportTypes)" :key="key">{{ reportTypes[key] }}</option>
                      </select>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
      <div class="column is-3" v-if="isShow">
        <div class="box">
          <div class="has-text-centered p-b-2">
            <p class="subtitle is-5 has-text-black m-t-25"><span class="requir"  >*</span>From Date
            </p>
            <div class="control">
              <input class="input" required type="date" title="From Date" v-model="fromDate"/>
            </div>
          </div>
        </div>
      </div>

      <div class="column is-3"  v-if="isShow">
        <div class="box">
          <div class="has-text-centered p-b-2" >
            <p class="subtitle is-5 has-text-black m-t-25"><span class="requir">*</span>To Date
            </p>
            <div class="control">
              <input class="input" required type="date" title="To Date" v-model="toDate"/>
            </div>
          </div>
        </div>
      </div>
        <div class="column is-3" v-if="isShowFranchiseeSelect" >
          <div class="has-text-centered p-b-2">
            <div class="content">
              <div class="field">
                <p class="subtitle is-5 has-text-black m-t-25">Franchisee(Optional)</p>
                <div class="control">
                  <span class="select is-fullwidth">
                    <select required v-model="franchiseeID">
                      <option value="">---All Franchisee---</option>
                      <option :value="franchisee.id" v-for="franchisee in franchiseeArr"
                        :key="franchisee.id">{{ franchisee.companyName }}</option>
                    </select>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

    </div>
    <div class="columns ">
      <div class="column is-2"></div>
      <div class="column is-3">
        <b-button @click="getOrderDataCSV()" type="is-primary" size="is-large" icon-left="briefcase-download">Export
        </b-button>
      </div>
      <div class="column"></div>
    </div>
  </section>
</div>
</template>
<script>
// import moment from 'moment'
// @ is an alias to /src
import constants from '@/utils/constants'
import ExportUtility from '@/utils/exportUtility'

import moment from 'moment'

export default {
  name: 'LedgerReportDetails',

  data () {
    return {
      ledgerData: [],
      franchiseeArr: [],
      fromDate: new Date(),
      toDate: new Date(),
      isShow: false,
      isShowFranchiseeSelect: false,
      franchiseeID: '',
      loadingComponent: null,
      fName: 'OrderReport',
      reportType: '',
      reportTypes: constants.OrderTatsRrportType
    }
  },

  async created () {
    this.fromDate = moment(this.fromDate)
      .add(-1, 'day')
      .format('YYYY-MM-DD')
    this.toDate = moment(this.toDate)
      .add(0, 'day')
      .format('YYYY-MM-DD')
  },

  methods: {
    handleDateinput: async function () {
      switch (this.reportType) {
        case constants.OrderTatsRrportType.classWiseOrderTats:
          this.isShow = true
          this.isShowFranchiseeSelect = false
          break
        case constants.OrderTatsRrportType.cityWiseOrderCount:
          this.isShow = false
          this.isShowFranchiseeSelect = false
          break
        case constants.OrderTatsRrportType.statusWiseOrderTats:
          this.isShow = false
          this.isShowFranchiseeSelect = false
          break

        case constants.OrderTatsRrportType.intelliKitMatrixReport:
          this.isShow = false
          this.isShowFranchiseeSelect = true
          if (this.franchiseeArr.length === 0) {
            this.getFranchiseeList()
          }
          break
        default:
          this.isShow = false
          this.isShowFranchiseeSelect = false
      }
    },
    getOrderDataCSV: async function () {
      try {
        if (moment(this.toDate).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD') ||
        moment(this.fromDate).format('YYYY-MM-DD') > moment(new Date()).format('YYYY-MM-DD')) {
          return this.$buefy.dialog.alert({
            message: 'Date Should be less than or equal to Current Date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (moment(this.toDate).format('YYYY-MM-DD') < moment(this.fromDate).format('YYYY-MM-DD')) {
          return this.$buefy.dialog.alert({
            message: 'To Date should be greater than From Date',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (!this.reportType) {
          return this.$buefy.dialog.alert({
            message: 'Please Select Report type',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        this.loadingComponent = this.$buefy.loading.open()

        this.fName = this.reportType
        switch (this.reportType) {
          case constants.OrderTatsRrportType.cityWiseOrderCount:
            const cityData = await http.get(`${constants.API_URL}/api/city-wise-order-tats`)
            if (cityData.data.length === 0) {
              return this.$buefy.dialog.alert({
                message: 'No Record in File',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.ledgerData = cityData.data
            break
          case constants.OrderTatsRrportType.classWiseOrderTats:
            let reportObj = {
              fromDate: this.fromDate,
              toDate: this.toDate
            }
            const classData = await http.get(`${constants.API_URL}/api/class-wise-order-tats`, {
              params: reportObj
            }
            )
            if (classData.data.length === 0) {
              return this.$buefy.dialog.alert({
                message: 'No Record in File',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.ledgerData = classData.data
            break
          case constants.OrderTatsRrportType.statusWiseOrderTats:
            const tatsReport = await http.get(`${constants.API_URL}/api/status-wise-order-tats`)
            if (tatsReport.data.length === 0) {
              return this.$buefy.dialog.alert({
                message: 'No Record in File',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.ledgerData = tatsReport.data
            break
          case constants.OrderTatsRrportType.intelliKitMatrixReport:
            let data = {}
            if (this.franchiseeID) {
              data.franchiseeID = this.franchiseeID
            }
            const matrixReport = await http.get(`${constants.API_URL}/api/report/intelli-kit-matrix`, {
              params: data
            })
            console.log(matrixReport)
            if (matrixReport.data.length === 0) {
              return this.$buefy.dialog.alert({
                message: 'No Record in File',
                type: 'is-danger',
                hasIcon: true,
                animation: 'zoom-out',
                size: 'is-medium',

                icon: ' mdi-exclamation',
                iconPack: 'mdi',
                ariaRole: 'alertdialog',
                ariaModal: true
              })
            }
            this.ledgerData = matrixReport.data
            break
        }
        this.total = this.ledgerData.count
        this.downloadCSVFile()
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order details', errorMessage)
        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } finally {
        this.loadingComponent.close()
      }
    },
    downloadCSVFile: async function () {
      try {
        if (this.ledgerData.length === 0) {
          this.$buefy.dialog.alert({
            message: 'No Record in File',
            type: 'is-danger',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }

        this.fName = this.fName + `${moment().format('DD-MM-YYYY')}`
        ExportUtility.convertToCsv(this.ledgerData, this.fName)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While Fetching Order details', errorMessage)

        return this.$buefy.dialog.alert({
          message: errorMessage,
          type: 'is-danger',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    getFranchiseeList: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/franchisee/active`)
        this.franchiseeArr = data.rows
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }
}
</script>
<style scoped>
.requir {
  color: red;
}
</style>
